export default __webpack_public_path__ + "static/media/alert.c68bd859.svg";